module.exports = __webpack_public_path__ + "img/developer-apply.0c395b8e.svg";